import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { timeFormat } from "../../../util/DateUtil";
import { findAll } from "../Aula/api-cronograma-aula";
import { errorMessage } from "../../../util/ConfirmAlertUtil";

const useStyles = makeStyles(theme => ({
  textTableHeader: {
    fontSize: 15,
    fontWeight: 'bold',
    lineHeight: '0.5',
    textAlign: 'center'
  },
  textHorario: {
    fontSize: 10,
    // fontWeight: 'bold',
    lineHeight: '0.2',
    textAlign: 'center'
  },
  textTableBody: {
    fontSize: 12,
    lineHeight: '0.5',
    textAlign: 'center'
  },
  cellStyle: {
    padding: '1px'
  }
}));


const CronogramaProfessorTableV2 = ({ cronogramas }) => {

  const classes = useStyles();
  const [listCronogramaAula, setListCronogramaAula] = useState([]);

  useEffect(() => {
    findAll().then((data) => {
      if (data) {
        if (data.error) {
          errorMessage(data.message);
        } else {
          setListCronogramaAula(data);
        }
      }
    })
  }, []);



  return (
    <Table size="small" aria-label="a dense table" >
      <TableHead>
        <TableRow>
          <TableCell>
            <p className={classes.textTableHeader}>
              Horário
            </p>
          </TableCell>
          <TableCell>
            <p className={classes.textTableHeader}>
              Segunda
            </p>
          </TableCell>
          <TableCell>
            <p className={classes.textTableHeader}>
              Terça
            </p>
          </TableCell>
          <TableCell>
            <p className={classes.textTableHeader}>
              Quarta
            </p>
          </TableCell>
          <TableCell>
            <p className={classes.textTableHeader}>
              Quinta
            </p>
          </TableCell>
          <TableCell>
            <p className={classes.textTableHeader}>
              Sexta
            </p>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {listCronogramaAula.map((ca) => {
          return (
            <>
              <TableRow
                style={{}}
                key={ca.codigo} >
                <TableCell padding='normal' className={classes.cellStyle}>
                  <p className={classes.textHorario}>
                    {timeFormat(ca.horarioInicio)} -{" "}
                    {timeFormat(ca.horarioFim)}
                  </p>
                </TableCell>
                {cronogramas.filter((cronogramaTotal) =>
                  cronogramaTotal.cronogramaAula.codigo === ca.codigo).map((c) =>
                  (
                    <TableCell padding='normal'>
                      <p className={classes.textTableHeader}>
                        {c.tdp && c.tdp.disciplina ? c.tdp.disciplina.descricao.length > 20 ? c.tdp.disciplina.descricao.substring(0, 25) : c.tdp.disciplina.descricao : "--"}
                      </p>
                      <p className={classes.textTableBody}>
                        {c.tdp && c.tdp.turma && c.tdp.turma.descricaoAux ?
                          <>
                            {c.tdp && c.tdp.turma && c.tdp.turma.descricaoAux ? c.tdp.turma.descricaoAux + " - " : ""}
                          </> : <>
                            {c.tdp && c.tdp.turma && c.tdp.turma.descricao ? c.tdp.turma.descricao + " - " : ""}
                          </>}


                        {c.local ? c.local.descricao : ""}
                      </p>
                    </TableCell>
                  ))}

              </TableRow>
            </>
          )


        }
        )}

      </TableBody>
    </Table>
  );
};

export default CronogramaProfessorTableV2;
